import jquery from 'jquery';
import 'bootstrap';

window.$ = window.jQuery = window.jquery = jquery;

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        'accept': 'image/webp'
    }
});

$.postJSON = function(url, data, callback) {
    return jQuery.ajax({
        'type': 'POST',
        'url': url,
        'headers': {
        'Accept': 'application/json'
        },
        'contentType': 'application/json',
        'data': JSON.stringify(data),
        'dataType': 'json',
        'success': callback
    });
};

window.showLoader = function() {
    jQuery('#global-loader').show();
};

window.hideLoader = function() {
    jQuery('#global-loader').hide();
};


class HeaderHeight {
	init() {
        this.setHeaderHeight();
        $(window).resize(() => {
            this.timeout ? clearTimeout(this.timeout) : null;
            this.timeout = setTimeout(() => {
                this.setHeaderHeight();
            }, 200)
        })
	}

    setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', $('header').height() + 'px');
    }
}
(new HeaderHeight()).init();